import { Card, Col, Row } from "react-bootstrap";
import { CreditAgencyList, getCurrencySymbol, isCountryUk, isCountryUs } from "../../../utils/country";
import { SubscriptionPlan } from "../../signup/SignUpApi";
import CreditClock from "../../../assets/settings/credit-clock.svg";
import { ISelected } from "./SubcriptionPlans";
import "./SubcriptionPlanInfo.scss";
import { useTranslation } from "react-i18next";
import equifaxSVG from "../../../assets/equifax.svg";
import experianSVG from "../../../assets/experian.svg";
import transunionSVG from "../../../assets/transunion.svg";
import { OnlyIf } from "../../common/OnlyIf";

export const SubscriptionPlanInfo = (props: {
  description: string[];
  highlightedPlan?: SubscriptionPlan & ISelected;
}) => {
  const { description, highlightedPlan } = props;
  const { t, ready } = useTranslation();
  if (!ready) {
    return null;
  }
  return (
    <Card className="mt-4 plan-info">
      <Card.Body>
        <Row className="mb-2 pt-2">
          <OnlyIf condition={isCountryUk()}>
            <Col className="text-center border-end" md={{ span: 3, offset: 1 }}>
              <img src={experianSVG} height={35} className="mx-2 experian" alt="Experian" />
            </Col>
            <Col className="text-center border-end" md={4}>
              <img src={equifaxSVG} height={35} className="mx-4 equifax" alt="Equifax" />
            </Col>
            <Col className="text-center" md={3}>
              <img src={transunionSVG} height={28} className="mx-4 transunion" alt="TransUnion" />
            </Col>
          </OnlyIf>
        </Row>

        <div className="text-center mb-3">
          <h3 className="plan-info-title">
            {t("subscription.subscriptionInfo.buildCredit")}{" "}
            <span className="fw-bolder">{t("subscription.subscriptionInfo.now")}</span>
          </h3>
          <p className="plan-info-subtitle">
            {t(`subscription.subscriptionInfo.subHeaderBuildCredit${isCountryUk() ? "Short" : ""}`, {
              creditAgencies: CreditAgencyList,
            })}
          </p>
        </div>

        <Row className="justify-content-center">
          <OnlyIf condition={!isCountryUs()}>
            <Col xs={12} md={5} className="clock-img pb-3 text-center">
              <img className="w-10" src={CreditClock} alt={t("subscription.subscriptionInfo.now")} />
            </Col>
          </OnlyIf>
          <Col xs={12} md={isCountryUs() ? 10 : 7} className="plan-info-items-col">
            {description.map((item, index) =>
              item.includes("%CREDIT_LIMIT%") ? (
                <div key={index} className="plan-info-row">
                  <span className="plan-info-check">✓</span>
                  <span className="plan-info-text">
                    <span className="credit-limit" data-cy="plan-info-credit-limit">
                      {item.replace(
                        "%CREDIT_LIMIT%",
                        `${getCurrencySymbol(highlightedPlan?.currency)}${highlightedPlan?.creditAmount ?? "0"}`
                      )}
                    </span>
                  </span>
                </div>
              ) : (
                <div key={index} className="plan-info-row">
                  <span className="plan-info-check">✓</span>
                  <span className="plan-info-text">{item}</span>
                </div>
              )
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
